module.exports = __webpack_public_path__ + "img/90501244.a3141a90.png";